import { Col, Layout, Menu, Row, Space, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { PoweroffOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;

const menuItems = [
  {
    label: 'Usuarios',
    key: 'usuarios',
    children: [
      {
        label: <a href={'/usuarios-internos'}>Usuarios Internos</a>,
        key: 'usuarios-internos',
      },
      {
        label: <a href={'/usuarios-clientes'}>Usuarios Clientes</a>,
        key: 'usuarios-clientes',
      },
    ],
  },
  {
    label: <a href={'/clientes'}>Clientes</a>,
    key: 'clientes',
  },
  {
    label: <a href={'/recolecciones'}>Recolecciones</a>,
    key: 'recolecciones',
  },
  {
    label: <a href={'/en-piso'}>En piso</a>,
    key: 'en-piso',
  },
  {
    label: <a href={'/en-transito'}>En tránsito</a>,
    key: 'en-transito',
  },
  {
    label: <a href={'/entregados'}>Entregados</a>,
    key: 'entregados',
  },
  {
    label: <a href={'/vehiculos'}>Vehículos</a>,
    key: 'vehiculos',
  },
  {
    label: <a href={'/vehiculos-en-servicio'}>Vehículos en servicio</a>,
    key: 'vehiculos-en-servicio',
  },
  {
    label: <a href={'/busqueda'}>Búsqueda</a>,
    key: 'busqueda',
  },
  {
    label: 'Configuración',
    key: 'configuracion',
    children: [
      {
        label: <a href={'/codigos-postales'}>Códigos postales</a>,
        key: 'codigos-postales',
      },
      {
        label: <a href={'/zonas'}>Zonas</a>,
        key: 'zonas',
      },
      {
        label: <a href={'/precios'}>Precios</a>,
        key: 'precios',
      },
    ],
  },
  {
    label: <a href={'/guias-prepagadas'}>Guias Prepagadas</a>,
    key: 'guias-prepagadas',
  },
  {
    label: <a href={'/credito'}>Crédito</a>,
    key: 'credito',
  },
];

export default function ProtectedLayout() {
  const { user, loading, logout } = useAuth();
  const [current, setCurrent] = useState('usuarios-internos');
  const location = useLocation();

  useEffect(() => {
    const currentLocation = location.pathname.slice(1);
    const findKey = menuItems.find((i) => {
      if (i.children) {
        return i.children.find((j) => j.key === currentLocation);
      }
      return i.key === currentLocation;
    });
    if (findKey) {
      setCurrent(currentLocation);
    }
  }, []);

  if (loading) {
    return (
      <Row style={{ minHeight: '100vh', textAlign: 'center' }} justify="center" align="middle">
        <Col span={4} xs={24}>
          <Spin />
        </Col>
      </Row>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout className="layout">
      <Header>
        <Row>
          <Col sm={1} xs={0}>
            <a className="logo" href={'/usuarios-internos'} />
          </Col>
          <Col sm={21}>
            <Menu theme="light" mode="horizontal" items={menuItems} selectedKeys={[current]} />
          </Col>
          <Col sm={2}>
            <Menu
              theme="light"
              mode="horizontal"
              selectable={false}
              items={[
                {
                  label: (
                    <Space onClick={logout}>
                      <PoweroffOutlined />
                      <span>Cerrar Sesión</span>
                    </Space>
                  ),
                  key: 'logout',
                },
              ]}
            />
          </Col>
        </Row>
      </Header>
      <Content style={{ padding: '20px 50px', background: '#eff3f8' }}>
        <Outlet />
      </Content>
    </Layout>
  );
}
